import styled from '@emotion/styled';

import UpdateIcon from '@/assets/icons/icon_odds_update.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const FlexWrapper = styled.div(
  (props: {
    alignItems?: string;
    justifyContent?: string;
    direction?: string;
    width?: string;
  }) =>
    mq({
      display: 'flex',
      flexDirection: props.direction,
      justifyContent: props.justifyContent,
      alignItems: props.alignItems,
      width: props.width ? props.width : '100%',
    }),
);

export const RaceInfoWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `${defaultTheme.spacing.xs} solid ${defaultTheme.border.color.lightGray}`,
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.l,
  }),
);

export const RaceInfo = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    fontSize: defaultTheme.font.size.s,
    fontWeight: 'bold',
    span: {
      fontSize: defaultTheme.font.size.xl,
      marginRight: defaultTheme.spacing.xs,
    },
  }),
);

export const DeadLineText = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.base,
    marginTop: defaultTheme.spacing.s,
  }),
);

export const OddsUpdateText = styled.span(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    fontSize: defaultTheme.font.size.s,
  }),
);

export const OddsUpdateIcon = styled.i(() =>
  mq({
    width: '12px',
    height: '14px',
    backgroundImage: `url(${UpdateIcon})`,
    backgroundSize: 'cover',
    marginLeft: defaultTheme.spacing.xs,
  }),
);

export const TicketInfo = styled.div(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.l,
  }),
);

export const TicketTypeWrapper = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    p: {
      lineHeight: defaultTheme.font.height.base,
      marginBottom: defaultTheme.spacing.s,
    },
  }),
);

export const TicketCount = styled.span(() =>
  mq({
    display: 'block',
    lineHeight: defaultTheme.font.height.base,
  }),
);

export const FundWrapper = styled.div(() =>
  mq({
    margin: `${defaultTheme.spacing.m} 0 ${defaultTheme.spacing.l}`,
  }),
);

export const FundSettingArea = styled.div(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.l,
    margin: `${defaultTheme.spacing.xs} 0`,
  }),
);

export const ButtonWrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    '& > button': {
      marginLeft: defaultTheme.spacing.s,
    },
  }),
);

export const DetailWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    marginTop: defaultTheme.spacing.l,
  }),
);

export const Detail = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: defaultTheme.font.size.m,
    marginBottom: defaultTheme.spacing.l,
    p: {
      fontSize: defaultTheme.font.size.xs,
      lineHeight: defaultTheme.font.height.base,
      color: defaultTheme.color.grayScale.dark,
    },
    span: {
      display: 'inline-block',
      textAlign: 'right',
    },
  }),
);
